import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const ProviderModule = {
  namespaced: true,

  state: {
    provider: {},
    providers: []
  },

  getters: {
  },

  actions: {
    async activateProvider ({ commit, state }, providerId) {
      commit('setLoading', true, { root: true })

      await PaApi().put(
        '/admin/providers/' + providerId + '/activate'
      ).then((resp) => {
        commit('storeProvider', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async deactivateProvider ({ commit, state }, providerId) {
      commit('setLoading', true, { root: true })

      await PaApi().delete(
        '/admin/providers/' + parseInt(providerId) + '/deactivate'
      ).then((resp) => {
        commit('storeProvider', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getProviders ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/providers/'
      ).then((resp) => {
        commit('storeProviders', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getProvider ({ commit, state }, providerId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/providers/' + parseInt(providerId)
      ).then((resp) => {
        commit('storeProvider', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async createProvider ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().post(
        '/admin/providers', {
          provider: state.provider
        }
      ).then((resp) => {
        commit('storeProvider', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    newProvider ({ commit, state }) {
      commit('storeProvider', {})
    },

    async updateProvider ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().put(
        '/admin/providers/' + parseInt(state.provider.id), {
          provider: state.provider
        }
      ).then((resp) => {
        commit('storeProvider', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async destroyProvider ({ commit, state }, providerId) {
      commit('setLoading', true, { root: true })

      await PaApi().delete(
        '/admin/providers/' + parseInt(providerId)
      ).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    setAuthorIds ({ commit, state }, authorIds) {
      commit('setAuthorIds', authorIds)
    },

    setNewsletterTypeIds ({ commit, state }, newsletterTypeIds) {
      commit('setNewsletterTypeIds', newsletterTypeIds)
    },

    setFrequency ({ commit, state }, freq) {
      commit('storeFrequency', freq)
    }
  },

  mutations: {
    setAuthorIds (state, authorIds) {
      state.provider.author_ids = authorIds
    },

    setNewsletterTypeIds (state, newsletterTypeIds) {
      state.provider.provider_newsletter_type_ids = newsletterTypeIds
    },

    storeFeaturedAuthors (state, authorIds) {
      state.provider.authors = authorIds
    },

    storeFrequency (state, freq) {
      state.provider.frequency = freq
    },

    storeProvider (state, payload) {
      baseOpts.recursive = true
      state.provider = processSuccess(payload, baseOpts)
    },

    storeProviders (state, payload) {
      baseOpts.recursive = true
      state.providers = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/ProviderModule.js